export const ROUTES = {
  home: '/',
  login: '/auth/signin',
  loginOTP: '/auth/signin/otp',
  signup: '/auth/signup',
  changePassword: '/auth/password/change',
  authResetPassword: '/auth/reset-password',
  authForgotPassword: '/auth/reset-password',
  forgotPassword: '/auth/forgot-password',
  resetPassword: '/auth/reset-password',
  settings: '/settings',
  users: '/users',
  usersRolesAndPermissions: '/users/roles-and-permissions',
  auditLogs: '/audit-logs',
  accountSetting: '/settings/account',
  enterpriseInfosSettings: '/settings/enterprise-infos',
  accountSecurity: '/settings/security',
  salesFormats: '/sales-formats',
  establishments: '/establishments',
  establishmentCreation: '/establishments/creation',
  salesPoint: '/sales-point',
  organizationList: '/organizations',
  organizationInfos: '/organizations/infos',
  organizationSecurity: '/organizations/security',
  stickers: '/stickers',
  stickersCheckoutSucceed: '/stickers/checkout/succeed',
  onboarding: '/onboarding',
  invoices: '/invoices',
  invoicesIssued: '/invoices/issued',
  invoiceGeneration: '/invoices/generate',
  invoiceGenerationCreditNote: '/invoices/generate-credit-note',
  invoiceIssuing: '/invoices/issuing',
  invoicePublicSearch: '/verification/invoice',
  companyPublicSearch: '/verification/ncc',
  taxList: '/taxes',
  taxProfileList: '/tax-profiles'
};
